import { render, staticRenderFns } from "./CitiesCarousel.vue?vue&type=template&id=973ff5e6&scoped=true"
import script from "./CitiesCarousel.vue?vue&type=script&lang=js"
export * from "./CitiesCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973ff5e6",
  null
  
)

export default component.exports